<div class="modal-body width-600">
  <div class="layout-auto-1-auto">
    <span class="modal-header">
      {{getResource('Upload')}}
    </span>
    <div class="content">
      <div class="layout-auto-1">
        <div>
          <div class="grid cols-2">
          <div>
	          <app-exg-select-enumeration [value]="uiSelectDocumentType"
                                        (valueChange)="setDocumentType($event)"
                                        [caption]="enumSvc.getFieldCaption('Dokument','dok_enmIdent_DokTyp')"
                                        enumerationName="DokTyp"
                                        [sortAlphabetical]="false">
            </app-exg-select-enumeration>
          </div>
          <div class="app-awacs-checkbox">
            <ng-container *ngIf="userType === 1">
              Freigabe Trackingportal:
              <input type="checkbox" [checked]="uiModel.dokTrackingPortalShare"
                     (change)="uiModel.dokTrackingPortalShare= !uiModel.dokTrackingPortalShare">
            </ng-container>
          </div>
        </div>
          <div>
            <exg-textarea [(ngModel)]="uiModel.dokDescription" [caption]="getTranslation('Kommentar')"
                          type="text" #nodeText name="apiDescription">
            </exg-textarea>
          </div>
          <div>
            <form #EigForm="ngForm">
              <ng-container *ngFor="let prop of dokEigenschaftTypList">
                <exg-input *ngIf="prop.det_enmIdent_DeigFormat === 1" [(ngModel)]="dokEigenschaftHelper[prop.detIdent]"
                           type="text" [name]="prop.detName" hintText="*"
                           [caption]="prop.detName" [required]="prop.detRequired"></exg-input>
                <exg-input *ngIf="prop.det_enmIdent_DeigFormat === 2" [(ngModel)]="dokEigenschaftHelper[prop.detIdent]"
                           type="date" [name]="prop.detName"
                           [caption]="prop.detName" [required]="prop.detRequired"></exg-input>
              </ng-container>
            </form>
          </div>
          <div (filesSelect)="onFilesSelect($event)"
               (filesSelectChunked)="onFilesSelectChunked($event)"
               [multiple]="true"
               [dnd]="true"
               class="app-drag-drop" appExgDirectUploadV2>
            {{getRessource('Uploadfield')}}
          </div>
        </div>
        <div class="content"  style="max-height: 232px">
          <div *ngFor="let selectedFile of selectedFiles; let i = index">
            <div class="list-row  list-single-line list-row-auto-1-auto typo-small"
                 *ngIf="selectedFile && selectedFile.extension">
              <div class="list-icon">
                <i class="far" flow="right"
                   [class.c-red]="!proofFileSize(selectedFile.size)"
                   [class.fa-exclamation-triangle]="!proofFileSize(selectedFile.size)"
                   [tooltip]="!proofFileSize(selectedFile.size) ? getRessource('NoSupported') : selectedFile.name"

                   [class.fa-file-pdf]="proofFileSize(selectedFile.size) && selectedFile.extension.toUpperCase() === 'PDF'"
                   [class.fa-file-excel]="proofFileSize(selectedFile.size) && selectedFile.extension.toUpperCase() === 'XLSX'"
                   [class.fa-file-word]="proofFileSize(selectedFile.size) && selectedFile.extension.toUpperCase() === 'DOCX'"
                   [class.fa-file-image]="proofFileSize(selectedFile.size) && (selectedFile.extension.toUpperCase() === 'JPEG'
                                        || selectedFile.extension.toUpperCase() === 'PNG')"
                   [class.fa-file]="proofFileSize(selectedFile.size) && !['PDF','XLSX','DOCX','PDF','PNG'].includes(selectedFile.extension.toUpperCase())">
                </i>
              </div>
              <span class="list-primary-text"
                    [class.c-red]="!proofFileSize(selectedFile.size)">
                {{
                  (i+1) + '.: ' + getResource('File', {
                      Filename: selectedFile.name,
                      Filesize: appSvc.file.calcFileSize(selectedFile.size, false)
                                + (!proofFileSize(selectedFile.size) ? ' - ' + getRessource('NoSupported') : '')
                    }) + ' '
                }}
            </span>
              <div>
                <i (click)="delete(selectedFile)"
                   [class.c-red]="!proofFileSize(selectedFile.size)"
                   [class.fa-trash]="proofFileSize(selectedFile.size)"
                   [class.fa-times]="!proofFileSize(selectedFile.size)"
                   class="fa-regular search-filter-action">
                </i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spawn-modal-actions">
      <button (click)="close()" class="md-btn">
        {{getGlobal('Cancel')}}
      </button>
      <button (click)="upload()"
              [disabled]="getFiles().length == 0 || EigForm.invalid"
              class="md-btn">
        {{getRessource('Upload')}}
      </button>
    </div>
  </div>
</div>
